import React from "react";
import Logo from "/home/azhar/phase-3-project-frontend/src/Buycars.png";

function Log() {
  return (
    <div className="logo">
    <div className="logo-card">
      <img src={Logo} alt="company logo" className="logo-image" />
    </div>
    <h1 className="logo-text">Welcome to Valetroni - Where Your Dream Rides Begin!</h1>
  </div>
  
  );
}

export default Log;
